import React, { useContext, useRef, useState } from 'react';
import Button from '../../NecttosComp/Button/Button';
import message from 'antd/lib/message';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getMainAccounts, getScholarship } from '../../NecttosComp/APICaller/ApiServices';

import Input2 from '../../NecttosComp/Input/Input2';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import { Table, Tbody, Td, Th, Thead, Tr } from '../../NecttosComp/Table/Table';
import SearchableUserInput from '../../myComp/SearchableUserInput';
import Instruction from '../../Documentation/Instruction';

export const Scholarship = ({ onClose }) => {
	const { collegeId, collegeList } = useContext(FirebaseContext);
	const componentRef = useRef();
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);

	const { data = [], refetch } = useQuery('getScholarship', getScholarship(collegeId));
	const { data: accountData = [] } = useQuery(['getMainAccounts', collegeId], getMainAccounts(collegeId));

	const [state, setState] = useState({});
	const [adding, setAdding] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const manageHolidays = async () => {
		try {
			setIsLoading(true);
			const instance = await getAxiosTokenInstance();

			const resp = await instance.post('/college/action/postScholarship', {
				collegeId,
				userId: state?._id,
				amount: state?.amount,
				naration: state?.naration,
				scholarshipType: state?.scholarshipType,
				mainAccountId: state?.mainAccountId,
				_id: state?.spId,
			});

			if (resp.data.statusCode !== 200) {
				throw new Error(resp.data.message || 'API Error');
			}

			setState({});
			refetch();
			setAdding(false);
		} catch (error) {
			message.error(error?.response?.data?.message || error?.message || 'API Error');
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Main title="Scholarship Management" width='90vw' height='90vh'>
			<Header>
				<div className="flex" />
				<div className="flex gap-2">
					<Button
						type="fetch"
						onClick={() => {
							setState({});
							setAdding(true);
						}}
					>
						Add New
					</Button>

					<Button type="refresh" onClick={refetch}>
						Reload
					</Button>
                   <Instruction keyId={'scholarship'}></Instruction>
					<Button type="print" tableRef={componentRef.current}>
						Print
					</Button>

					<Button type="close" onClick={onClose}>
						Close
					</Button>
				</div>
			</Header>

			<Body>
				<div ref={componentRef} className="printable relative print:bg-white print:text-black">
					<img
						className="absolute w-[80%] top-[350px] left-1/2 -translate-x-1/2 opacity-10 -z-10"
						src={selectedCollege?.logo}
						alt="College Logo"
					/>

					<Table width="100%" innerWidth={['5%', '10%', '15%', '15%', '10%', '10%', '10%', '10%', '10%']}>
						<Thead>
							<Tr>
								<Th position={0}>Sn</Th>
								<Th position={1}>AdmissionNo</Th>
								<Th position={2}>Account Name</Th>
								<Th position={3}>Name</Th>
								<Th position={4}>Class Name</Th>
								<Th position={5}>Amount</Th>
								<Th position={6}>Type of Scholarship</Th>
								<Th position={7}>Naration</Th>
								 <Th position={8} className="print:hidden"></Th>
							</Tr>
						</Thead>
						<Tbody>
							{data?.map((item, i) => (
								<Tr key={i}>
									<Td index={i} position={0}>{i + 1}</Td>
									<Td index={i} position={1}>{item.admisionNo}</Td>
									<Td index={i} position={2}>{item.mainAccountName}</Td>
									<Td index={i} position={3}>{item.name}</Td>
									<Td index={i} position={4}>{item.className}</Td>
									<Td index={i} position={5}>{item.amount}</Td>
									<Td index={i} position={6}>{item.scholarshipType}</Td>
									<Td index={i} position={7}>{item.naration}</Td>
									 <Td index={i} position={8} className="print:hidden">
										<div className='print:hidden flex justify-center'>
										<Button
											type="edit"
											className="mx-auto "
											onClick={() => {
												setState({
													_id: item?.userId || '',
													amount: item?.amount || '',
													mainAccountId: item?.mainAccountId || '',
													admisionNo: item?.name || '',
													scholarshipType: item?.scholarshipType || '',
													mainAccountIdval: item?.mainAccountName || '',
													naration: item?.naration || '',
													spId: item?.spId || '',
													alert: `Edit as ${item?.admisionNo || ''}`,
												});
												setAdding(true);
											}}
										>
											Edit
										</Button>
										</div>
									</Td>
								</Tr>
							))}
						</Tbody>
					</Table>
				</div>
			</Body>

			{adding && (
				<Main
					height="698px"
					width="50%"
					title={state?.spId ? 'Edit Scholarship' : 'Add Scholarship'}
				>
					<Header />
					<Body bgColor="red">
						<div className="flex flex-col h-full w-full rounded-2xl overflow-y-scroll shadow-md p-6">
							<h3 className="text-xl mb-4 text-center font-black dark:text-white">
								{state?.spId && state?.alert ? state.alert : 'Add New'}
							</h3>

							<SearchableUserInput
								primoryKey="admisionNo"
								secondaryKey="name"
								tertiaryKey="phoneNumber"
								collection="users"
								stateData={state}
								setStateData={setState}
								titleData="Search Students"
							/>

							<Input2
								type="number"
								returnKey="amount"
								fieldName="Amount"
								state={state}
								setState={setState}
							/>

							<Input2
								type="text"
								returnKey="scholarshipType"
								fieldName="Scholarship Type"
								state={state}
								setState={setState}
							/>

							<Input2
								className="w-[689px]"
								type="drop"
								returnKey="mainAccountId"
								fieldName="Select Account"
								optionKey="_id"
								optionDisplay="name"
								options={accountData}
								state={state}
								setState={setState}
								didntShowKey={true}
							/>

							<Input2
								type="text"
								returnKey="naration"
								fieldName="Naration"
								state={state}
								setState={setState}
							/>
						</div>
					</Body>

					<div className="flex justify-around self-center my-4">
						<Button
							type="close"
							onClick={() => {
								setState({});
								setAdding(false);
							}}
						>
							Cancel
						</Button>

						<Button 
							type="submit"
							onClick={manageHolidays}
						>{state?.spId ? 'Update' : 'Submit'}
							
						</Button>
					</div>
				</Main>
			)}
		</Main>
	);
};

export default Scholarship;
